import React, { memo } from 'react'

const NotificationDot = memo(() => {
  return (
    <div className="relative w-2 h-2 ml-auto shrink-0">
    <div className="absolute inset-0 w-2 h-2 rounded-full bg-red-500 animate-ping" />
    <div className="w-2 h-2 rounded-full bg-red-500" />
  </div>
  )
})

export default NotificationDot
